import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import * as _ from 'lodash';

@Component({
    styles: [`
        mat-dialog-content {
            width: 525px;
        }
    `],
    template: `
        <h2 mat-dialog-title>Add payment method</h2>
        <mat-dialog-content>
            <credit-card-form (cardProcessed)="save(true)" [isUser]="isUser" (cancel)="save()"></credit-card-form>
        </mat-dialog-content>
    `
})
export class PaymentEditorDialogComponent {
    isUser: boolean;

    constructor(private dialogRef: MatDialogRef<PaymentEditorDialogComponent>,
                @Optional() @Inject(MAT_DIALOG_DATA) data) {
        this.isUser = data && data.isUser;
    }

    save = (result?) => this.dialogRef.close(result);
}
